
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { CopyrightFAQ } from './types';

interface CopyrightFAQSectionProps {
  faqs: CopyrightFAQ[];
}

const CopyrightFAQSection: React.FC<CopyrightFAQSectionProps> = ({ faqs }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Copyright FAQ</CardTitle>
        <CardDescription>
          Common questions about music copyright
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index}>
              <h3 className="font-medium mb-1">{faq.question}</h3>
              <p className="text-sm text-muted-foreground">{faq.answer}</p>
              {index < faqs.length - 1 && <Separator className="my-3" />}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CopyrightFAQSection;
